// extracted by mini-css-extract-plugin
export default {"container":"SavedFiltersSelect_container__kw1tl","publicType":"SavedFiltersSelect_publicType__sj1Z7"};